/**
 * Tiered pricing
 */
class tieredPricing extends HTMLElement {
  constructor() {
    super();

    // Window values
    const {
      locale,
      money_format,
      tiers,
    } = window.tieredPricing;

    this.locale = locale;
    this.moneyFormat = money_format.replace('{{amount_with_comma_separator}}', '').replace('{{amount}}', '');
    this.tiers = tiers;

    // Data attributes
    this.preventDiscount = (this.dataset.preventDiscount === 'true');
  }

  /**
   * Format price
   * @param { Integer } price
   * @returns local formatted price with 2 decimals
   */
  formatPrice(price) {
    const formatter = new Intl.NumberFormat(this.locale, {
      minimumFractionDigits: 2,      
      maximumFractionDigits: 2,
    });

    return formatter.format(price / 100);
  }
}


/**
 * Quantity input
 */
 class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.currentTarget.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

if (!customElements.get("quantity-input")) {
  customElements.define("quantity-input", QuantityInput);
}


/**
 * Tiered pricing price
 */
class tieredPricingPrice extends tieredPricing {
  constructor() {
    super();

    this.price = this.dataset.priceRegular;
    this.priceSale = this.querySelector('[data-tiered-price-sale]');
    this.priceRegular = this.querySelector('[data-tiered-price-regular]');
    this.priceRegularMoney = this.dataset.priceRegularMoney;

    this.tiered_pricing_item_count = 1;
    this.countElements = this.querySelectorAll('[data-tiered-pricing-item-count]');
    this.countElements.forEach(element => {
      this.tiered_pricing_item_count = element.dataset.tieredPricingItemCount;
    });

    this.tiers.forEach(({
      tiered_pricing_threshold,
      tiered_pricing_discount
    }) => this.handlePrice(this.tiered_pricing_item_count, tiered_pricing_threshold, tiered_pricing_discount));
  }

  handlePrice(value, threshold, discount) {
    // If discount is prevented, do nothing
    if (this.preventDiscount) return

    const { tiered_pricing_item_count } = window.tieredPricing
    let inputValue = value ? value : tiered_pricing_item_count;

    // If window has more then 1 item and value is true, add the value to the window count - 1
    inputValue = (tiered_pricing_item_count > 1 && value) ? (tiered_pricing_item_count + (value - 1)) : inputValue

    if (inputValue >= threshold) {
      const discountMultiplier = (100 - discount) / 100;

      const salePrice = this.formatPrice((this.price * discountMultiplier));

      // Set the right prices
      const htmlSalePrice = `${this.moneyFormat}${salePrice}`.replace('{{amount_no_decimals}}', '');

      this.priceSale.innerHTML = htmlSalePrice;
      this.priceRegular.innerHTML = this.priceRegularMoney;
      
    // If value is lower than the lowest threshold, reset the price
    } else if (inputValue < this.tiers[0].tiered_pricing_threshold) {
      this.priceSale.innerHTML = this.priceRegularMoney;
      this.priceRegular.innerHTML = '';
    }
  }
}

if (!customElements.get('tiered-pricing-price')) {
  customElements.define('tiered-pricing-price', tieredPricingPrice);
}


/**
 * Tiered pricing badge
 */
 class tieredPricingBadge extends tieredPricing {
  constructor() {
    super();

    this.badge = this.querySelector('.product__badge--tiered-sale');
    this.badgeDiscountTypeName = this.dataset.discountTypeName;

    // DOM values
    this.tiers.forEach(({tiered_pricing_threshold, tiered_pricing_discount}) => {
      if (this.badge) {
        this.handleBadge(false, tiered_pricing_threshold, tiered_pricing_discount)
      }
    });
  }

  handleBadge(value, threshold, discount) {
    // If discount is prevented, do nothing
    if (this.preventDiscount) return

    const { tiered_pricing_item_count } = window.tieredPricing
    let inputValue = value ? value : tiered_pricing_item_count;

    // If window has more then 1 item and value is true, add the value to the window count - 1
    inputValue = (tiered_pricing_item_count > 1 && value) ? (tiered_pricing_item_count + (value - 1)) : inputValue


    if (inputValue >= threshold) {
      this.classList.remove('product__badges--hidden');
      if (this.badge) { 
        this.badge.classList.remove('product__badge--hidden');
        this.badge.innerHTML = `
        ${discount * -1}%
        <span class="product__badge--tiered-sale-label">${this.badgeDiscountTypeName}</span>
        `;
      }

    // If value is lower than the lowest threshold, reset the badge
    } else if (inputValue < this.tiers[0].tiered_pricing_threshold) {
      this.classList.add('product__badges--hidden');
      if (this.badge) {
        this.badge.classList.add('product__badge--hidden');
        this.badge.innerHTML = `
        0%
        <span class="product__badge--tiered-sale-label">${this.badgeDiscountTypeName}</span>
        `;
      }
    }
  }
}

if (!customElements.get('tiered-pricing-badge')) {
  customElements.define('tiered-pricing-badge', tieredPricingBadge);
}
